<div class="chips-filters">
  @for (item of options; track item) {
    <div
      class="chips-filters-option"
      [class.selected]="item.key === selectedOption"
      (click)="selectOption.emit(item.key)">
      {{ item.label | translate }}
    </div>
  }
</div>
